import * as React from "react"

function Succes(props) {
  return (
    <svg width="16" height="16" fill="white"  viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fill="#41ad49"  
        d="M434.8 49L174.2 309.7l-97.4-97.4L0 289.2l174.1 174.1 22.5-22.4 315.1-315.1L434.8 49z"
      />
    </svg>
  )
}

export default Succes